import React from "react";
import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./SmartOrderPromo.css";

const SmartOrderPromo = () => {
  const { t, i18n } = useTranslation();
  const currentLang = i18n.language || "en";
  const features = t("smartOrder.features", { returnObjects: true }) || [];

  return (
    <div className="smart-order-promo">
      <div className="smart-order-ambient" aria-hidden="true" />
      <div className="smart-order-inner">
        <div className="smart-order-copy">
          <div className="smart-order-badge">{t("smartOrder.badge")}</div>
          <h2>{t("smartOrder.title")}</h2>
          <p className="smart-order-desc">{t("smartOrder.description")}</p>

          <ul className="smart-order-list">
            {Array.isArray(features) &&
              features.map((feature, idx) => <li key={idx}>{feature}</li>)}
          </ul>

          <div className="smart-order-cta">
            <a
              className="smart-order-btn primary"
              href="https://order.elyx.work"
              target="_blank"
              rel="noopener noreferrer"
            >
              {t("smartOrder.viewDemo")}
            </a>
            <NavLink
              to={`/get-in-touch?lang=${currentLang}`}
              className="smart-order-btn ghost"
            >
              {t("smartOrder.freeConsultation")}
            </NavLink>
          </div>
        </div>

        <div
          className="smart-order-card"
          aria-label="Smart Order live demo highlight"
        >
          <div className="smart-order-chip">{t("smartOrder.cardChip")}</div>
          <p className="smart-order-kicker">{t("smartOrder.cardKicker")}</p>
          <div className="smart-order-meta">
            <div className="meta-block">
              <span className="meta-label">
                {t("smartOrder.liveDemoLabel")}
              </span>
              <span className="meta-value">order.elyx.work</span>
            </div>
            <div className="meta-block">
              <span className="meta-label">{t("smartOrder.goLiveLabel")}</span>
              <span className="meta-value">{t("smartOrder.goLiveValue")}</span>
            </div>
          </div>
          <div className="smart-order-footer">
            <span className="status-dot" aria-hidden="true" />
            <span className="status-text">{t("smartOrder.footerText")}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SmartOrderPromo;
